import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import LImage from '@max/leez-image';
import Text from '@hfe/max-text';
import Button from '@hfe/max-button';
// import { rpx2px } from '@hfe/max-universal-unit-tool';
import './index.scss';
const LightUpSuccessModal = (props) => {
    const { onCityPress, onTeamPress } = props;
    return <View className="light-up-modal">
      <LImage className="light-up-modal-main" source={{
        uri: 'https://p0.meituan.net/ingee/0d4735a26e947a6121cdac86b78e7f1b377912.png'
    }} style={{
        width: '750rpx',
        height: '914rpx'
    }}>
        <View className="light-up-modal-title-wrap">
          <Text className="light-up-modal-sub-title">成功帮助好友</Text>
          <Text className="light-up-modal-title">点亮心愿城市</Text>
        </View>
        <View className="light-up-modal-buttons">
          <View className="light-up-modal-city-btn-wrap">
            <Button className="light-up-modal-btn" onPress={onCityPress}>
              <LImage source={{
        uri: 'https://img.meituan.net/makerjiulv/8557d1bbf099441e5c2cfd060d26183b9996.png'
    }} style={{
        width: '503rpx',
        height: '90rpx'
    }} borderRadius={0} resizeMode='cover'>
              </LImage>
            </Button>
            <View className="light-up-modal-tip">
              <View style={{
        // width: '167rpx',
        height: '38rpx',
        backgroundColor: '#FF2D19',
        borderTopLeftRadius: '25rpx',
        borderTopRightRadius: '19rpx',
        borderBottomRightRadius: '19rpx',
        borderBottomLeftRadius: '6rpx',
        padding: '0 10rpx',
        zIndex: 1
    }}>
                <Text className="light-up-modal-tip-text">订酒店 赢免单</Text>
              </View>
            </View>
          </View>
          <Button className="light-up-modal-btn" style={{
        marginTop: '20rpx'
    }} onPress={onTeamPress}>
            <LImage source={{
        uri: 'https://p0.meituan.net/ingee/922aaa44edb765904535fc57d272b3906527.png'
    }} style={{
        width: '503rpx',
        height: '90rpx'
    }} borderRadius={0} resizeMode='cover'/>
          </Button>
        </View>
      </LImage>
    </View>;
};
export default memo(LightUpSuccessModal);
